'use client'

import { useState } from 'react'
import { IconButton } from './icon-button'
import { PlayIcon } from './icon'
import { Image } from './image'
import { cn } from '../lib/utils'

export interface YoutubeEmbedProps {
  posterSrc?: string
  className?: string
  id: string
  title?: string
}

export function YoutubeEmbed({
  posterSrc,
  className,
  id,
  title = 'YouTube video',
}: YoutubeEmbedProps) {
  const [playing, setPlaying] = useState(false)
  const videoId = encodeURIComponent(id)

  return (
    <div
      className={cn(
        'bg-surface-2 relative aspect-video overflow-hidden rounded-2xl',
        className,
      )}
      data-youtube-embed=""
    >
      {playing ? (
        // oxlint-disable-next-line react/iframe-missing-sandbox -- YouTube requires scripts and same-origin; sandboxing both provides no isolation and breaks playback.
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="size-full border-0"
          data-testid="youtube-iframe"
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
          title={title}
        />
      ) : (
        <>
          <Image
            alt=""
            className="size-full"
            cover
            noThumb
            src={posterSrc ?? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <IconButton
              semanticRole="error"
              size="lg"
              variant="filled"
              onClick={() => {
                setPlaying(true)
              }}
            >
              <PlayIcon />
              {`Play ${title}`}
            </IconButton>
          </div>
        </>
      )}
    </div>
  )
}
